import { generateClient, GraphQLResult } from "aws-amplify/data";
import { useState, useEffect } from "react";

export default function KnowledgeBase() {
  // Map URLs to numbers as in Confluence
  const [knowledgeBaseUrl, setKnowledgeBaseUrl] = useState<string>("");
  const getKnowledgeBaseUrl = async () => {
    const client = generateClient({
      authMode: "identityPool",
    });
    const res = (await client.graphql({
      query: `
        query getKnowledgeBaseUrl {
            getKnowledgeBaseUrl{
              url
            }
        }
        `,
    })) as GraphQLResult<{ getKnowledgeBaseUrl: { url: string } }>;

    if (!res?.data.getKnowledgeBaseUrl.url) {
      throw new Error("Invalid response while getting knowledge base url");
    }
    setKnowledgeBaseUrl(res?.data.getKnowledgeBaseUrl.url);
  };

  useEffect(() => {
    getKnowledgeBaseUrl();
  }, []);

  return (
    <div>
      <iframe
        title="Knowledge Base"
        src={knowledgeBaseUrl}
        style={{
          minWidth: "80%",
          minHeight: "600px",
        }}
      />
    </div>
  );
}
